<form [formGroup]="flightNumberForm" (ngSubmit)="submitForm(flightNumberForm)">
    <adc-row>
        <adc-column col-desktop="12" col-tablet="12" col-phone="4">
            (<span aria-hidden="true" class="icon-required"></span> {{ 'global.required' | aai18n }}
            <span class="sr-text">{{ 'global.requiredIndicatorHidden' | aai18n }}</span>)
        </adc-column>
        <adc-column>
            <adc-notification id="errorNotification" title="{{ 'error:ERRCODE408.title' | aai18n }}" kind="error" *ngIf="errorCount > 0" class="notification-container">
                <span>
                    {{ errorMessage.helperText }} <a href="javascript:void(0)" (click)="focusFirstError()" class="error-link">{{ errorMessage.linkText }}</a>
                </span>
            </adc-notification>
        </adc-column>
    </adc-row>
    <adc-row>
        <adc-column col-desktop="4" col-tablet="4" col-phone="4">
            <adc-text-input #flightNumber
                            (keydown)="keyPressNumber($event)"
                            (keyup)="updateFlightNumber()"
                            formControlName="flightNumber"
                            ngDefaultControl
                            onInput="this.value = this.value.slice(0, 4)"
                            id="flightNumberInput"
                            attr.label-text="{{ 'flightStatus.flightNumber' | aai18n }}"
                            min="1"
                            hide-clear-button
                            required>
            </adc-text-input>
        </adc-column>
        <adc-column col-desktop="4" col-tablet="4" col-phone="4">
            <adc-select id="flightNumberDate" #flightNumberDate formControlName="flightNumberDate" name="travelDate" ngDefaultControl *ngIf="dates" attr.label-text="{{ 'flightStatus.date' | aai18n }}">
                <adc-select-item *ngFor="let date of dates"
                                 [attr.value]=" date.value " selected="{{ date.default ? 'selected' : '' }}">{{ date.item }}</adc-select-item>
            </adc-select>
        </adc-column>
    </adc-row>
    <adc-row>
        <adc-column col-desktop="8" col-tablet="4"></adc-column>
        <adc-column col-desktop="4" col-tablet="4" col-phone="4">
            <adc-button id="flightNumberSubmitButton" (click)="submitForm(flightNumberForm)" type="button" size="fullwidth">
                {{ 'global.search' | aai18n }}
            </adc-button>
        </adc-column>
    </adc-row>
</form>

<div *ngIf="showFormValue">Submitted Form: {{ submittedForm }}</div>
